export const atsFormUrl = "https://ats.kscan.io";
export const siteUrl = process.env.REACT_APP_FRONTEND_URL || "https://kscan.io";
export const offerPathTemplate = "/jobs/{id}";


// Backend API base URL
// Prod: public FastAPI base behind /kscan
// Dev: override at runtime or use a local config file
export const backendUrl = "https://kscan.io/kscan";

// Feature flags
export const enableMulticast = true;
